/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type AverageIssueAgeReportEntrypointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const averageIssueAgeReportEntrypoint: EntryPoint<
	AverageIssueAgeReportEntrypointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForUserVisible<AverageIssueAgeReportEntrypointComponent>(
		/* webpackChunkName: "async-reports-average-issue-age-entrypoint" */ './AverageIssueAgeReportPage.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => ({}),
});
